// removed by extract-text-webpack-plugin
module.exports = {"narrowMax":"1000","wideMax":"Infinity","narrow":"narrow","wide":"wide"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/app_prihum_tchr.scss
// module id = ODre
// module chunks = 6